import { connect } from 'react-redux';
import storage from 'app/services/storage';
import cinemasModule from 'app/store/cinemas';
import moviesModule from 'app/store/movies';
import AllCinemas from './AllCinemas.component';

const {
  requestCinemasWithMovies,
  requestDates,
  setCinemasWithMovies,
  setDates
} = cinemasModule.actions;

const {
  setDate
} = moviesModule.actions;

const mapDispatchToProps = {
  getCinemasWithMovies: requestCinemasWithMovies,
  getDates: requestDates,
  setCinemasWithMovies,
  setDates,

  setStoreDate: setDate,
};

const mapStateToProps = ({ cinemas, user, layout }) => (
  {
    cinemas: cinemas.withMovies,
    dates: cinemas.dates,
    locations: layout.locations,

    isLoggedIn: !!user.user,
    savedLocation: storage.getLocation()
  });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AllCinemas);
